import { render } from "./Copyright.vue?vue&type=template&id=fed110c8"
import script from "./Copyright.vue?vue&type=script&lang=js"
export * from "./Copyright.vue?vue&type=script&lang=js"

import "./Copyright.vue?vue&type=style&index=0&id=fed110c8&lang=css"
script.render = render

export default script